import React, { useState } from 'react';
import styles from './ChatPopup.module.scss'; // Import SCSS module
import Helpimage from 'i/Influencer.png';
import SearchIcon from 'i/icons/zoom.svg';

const ChatPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openChatPopup = () => setIsOpen(true);
  const closeChatPopup = () => setIsOpen(false);

  return (
    <>
    <div className={styles.imagecontainer}>
      <img
        className={styles.dashboard_help_img}
        src={Helpimage}
        alt="Help Icon"
        onClick={openChatPopup}
      />
      <div className={styles.textoverlay}>
        <div className={styles.icons}> <img
        
        src={SearchIcon}
        alt=""
        
      /></div>
        <span onClick={openChatPopup}>Need any help? Ask me anything</span>
      </div>
      </div>
      <div className={`${styles.chat_popup} ${isOpen ? styles.open : ''}`}>
        <button className={styles.close_button} onClick={closeChatPopup}>
          ×
        </button>
        <iframe
          src="https://chat.supportai.com/1ca8ddb59c38d0a/"
          frameBorder="0"
          title="Support Chat"
        ></iframe>
      </div>
    </>
  );
};

export default ChatPopup;
